import { render, staticRenderFns } from "./StartNewCustomProcess.vue?vue&type=template&id=b27d982e"
import script from "./StartNewCustomProcess.vue?vue&type=script&lang=js"
export * from "./StartNewCustomProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports